/**
 * 查询条件运算符
 * - equal：等于
 * - like：模糊匹配
 * - gt：大于
 * - lt：小于
 * - between：区间
 * - in：包含于集合
 * - belong：归属/隶属（按后端语义）
 */
export enum API_CONDITION_TYPE {
  EQUAL = 'equal',
  LIKE = 'like',
  GT = 'gt',
  LT = 'lt',
  BETWEEN = 'between',
  IN = 'in',
  BELONG = 'belong'
}

/**
 * 查询条件连接符
 * - and：与
 * - or：或
 */
export enum API_CONDITION_LINK_TYPE {
  AND = 'and',
  OR = 'or'
}

/**
 * 排序方向
 * - desc：降序
 * - asc：升序
 */
export enum API_ORDER_TYPE {
  DESC = 'desc',
  ASC = 'asc'
}
